__turbopack_context__.v({
  "active": "Tabs-module-scss-module__83KFmq__active",
  "borderedVariant": "Tabs-module-scss-module__83KFmq__borderedVariant",
  "defaultVariant": "Tabs-module-scss-module__83KFmq__defaultVariant",
  "ellipsisIcon": "Tabs-module-scss-module__83KFmq__ellipsisIcon",
  "fullVariant": "Tabs-module-scss-module__83KFmq__fullVariant",
  "liftedVariant": "Tabs-module-scss-module__83KFmq__liftedVariant",
  "moreItemsButton": "Tabs-module-scss-module__83KFmq__moreItemsButton",
  "overflowShadowBoth": "Tabs-module-scss-module__83KFmq__overflowShadowBoth",
  "overflowShadowLeft": "Tabs-module-scss-module__83KFmq__overflowShadowLeft",
  "overflowShadowRight": "Tabs-module-scss-module__83KFmq__overflowShadowRight",
  "pillVariant": "Tabs-module-scss-module__83KFmq__pillVariant",
  "promoOffer": "Tabs-module-scss-module__83KFmq__promoOffer",
  "secondaryTabsDropdown": "Tabs-module-scss-module__83KFmq__secondaryTabsDropdown",
  "selected": "Tabs-module-scss-module__83KFmq__selected",
  "tab": "Tabs-module-scss-module__83KFmq__tab",
  "tabContent": "Tabs-module-scss-module__83KFmq__tabContent",
  "tabList": "Tabs-module-scss-module__83KFmq__tabList",
  "tabListWrapper": "Tabs-module-scss-module__83KFmq__tabListWrapper",
  "tabsContainer": "Tabs-module-scss-module__83KFmq__tabsContainer",
});
